import { FileStateType } from '@/common/types/Files.type.ts';

export const myFilesStateDict: Record<FileStateType, string> = {
  [FileStateType.IN_PROGRESS]: 'درحال اجرا',
  [FileStateType.ARCHIVED]: 'باطل شده',
  [FileStateType.DELAY]: 'تاخیر خورده',
  [FileStateType.CANCELED]: 'باطل شده',
  [FileStateType.NEW]: 'پیشنهاد کارشناسی',
  [FileStateType.CLOSED]: 'بسته شده',
  [FileStateType.EDIT_REQUIRED]: 'نیازمند اصلاح شعبه',
  [FileStateType.REFER_FROM_BRANCH]: 'برگشتی از شعبه',
  [FileStateType.REFER_FROM_CHECKING]: 'برگشتی از واحد بررسی',
  [FileStateType.REFER_FROM_PROFESSIONAL]: 'برگشتی از کارشناس تخصصی',
  [FileStateType.REFER_TO_BRANCH]: 'برگشتی به شعبه',
  [FileStateType.SENT_TO_BRANCH]: 'ارسال شده به شعبه',
};
